import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import GridFilterSummary from "@/components/ui/grid/grid-filter-summary.vue";
import { ref, computed, onMounted, PropType } from "vue";
import { GridFilter } from "@/types/ui/GridFilter";
import { useCurrentUserStore } from "@/stores/CurrentUserStore";
import { CurrentUser } from "@/types/user/CurrentUser";
import { useUserPermissionsStore } from "@/stores/UserPermissionsStore";
import { UserPermissions } from "@/types/user/permissions/UserPermissions";
import { ContextMenuItem } from "@/types/ui/menus/ContextMenuItem";
import MaintenanceRequestsFiltersModal from "@/components/maintenance-requests/maintenance-requests-filters-modal.vue";
import { MaintenanceRequestListFilters } from "@/types/maintenance-requests/MaintenanceRequestListFilters";


export default /*#__PURE__*/_defineComponent({
  __name: 'maintenance-request-list-summary',
  props: {
  /**
   * The number of rows displayed in the component.
   * @type {number}
   * @required
   */
  rowCount: {
    type: Number,
    required: true,
  },
  /**
   * The MaintenanceRequestListFilters object value used with `v-model` to modal or component.
   * @type {MaintenanceRequestListFilters}
   * @required
   */
  modelValue: {
    type: Object as PropType<MaintenanceRequestListFilters>,
    required: true,
  },
  /**
   * The menu items to be displayed in the dropdown menu.
   * @type {ContextMenuItem[]}
   * @default {[]}
   */
  menuItems: {
    type: Array as PropType<ContextMenuItem[]>,
    default: () => [],
  },
  /**
   * Determines whether the header should be dark.
   * @type {boolean}
   * @default true
   */
  darkHeader: {
    type: Boolean,
    default: true,
  },
},
  emits: [
  /**
   * Triggered when the `modelValue` changes. This is used to update the v-model variable in the parent component.
   * @property {boolean} value - Indicates whether the modal has been opened or closed.
   */
  "update:modelValue",
  /**
   * Triggered when the user clicks on a menu item
   * @key {string} - key of the clicked menu item
   */
  "menuItemClick",
  /**
   * Triggered when the filters have been changed
   */
  "filtersChanged",
],
  setup(__props, { emit }) {

const props = __props;



const userPermissionsStore = useUserPermissionsStore();
const userPermissions = ref<UserPermissions>();
const currentUser = ref<CurrentUser>();
const currentUserStore = useCurrentUserStore();
const gridMenuId = ref("maintenance-request-summary-grid-menu-id");
const showFilters = ref(false);

const onFilterClick = () => (showFilters.value = true);

const filters = computed({
  get: () => props.modelValue,
  set: (value: MaintenanceRequestListFilters | undefined) =>
    emit("update:modelValue", value),
});



onMounted(async () => {
  currentUser.value = await currentUserStore.getCurrentUserDetails();
  userPermissions.value = await userPermissionsStore.getUserPermissions();
});

const summaryFilters = computed((): GridFilter[] => {
  const gridFilters: GridFilter[] = [];

  if (!filters.value) return [];

  if (filters.value.status?.id > -1) {
    gridFilters.push({
      title: "Status",
      values: [filters.value.status],
      dataSource: [],
    });
  }

  if (filters.value.branch?.id > -1) {
    gridFilters.push({
      title: "Branch",
      values: [filters.value.branch],
      dataSource: [],
    });
  }

  return gridFilters;
});

const onFiltersApplied = (modalFilter: MaintenanceRequestListFilters) => {
  emit("filtersChanged");
  filters.value = modalFilter;
};

const menuClicked = (key: string) => emit("menuItemClick", key);

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(GridFilterSummary, {
      gridMenuId: gridMenuId.value,
      filters: summaryFilters.value,
      "row-count": __props.rowCount,
      onFilterClick: onFilterClick,
      menuItems: props.menuItems,
      onMenuItemClick: menuClicked,
      dropdownMenuDisable: false,
      "dark-header": __props.darkHeader
    }, null, 8, ["gridMenuId", "filters", "row-count", "menuItems", "dark-header"]),
    _createVNode(MaintenanceRequestsFiltersModal, {
      onFiltersApplied: onFiltersApplied,
      modelValue: showFilters.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((showFilters).value = $event)),
      filter: filters.value,
      onMenuItemClick: menuClicked
    }, null, 8, ["modelValue", "filter"])
  ], 64))
}
}

})